// Debug-only routing screens/beacons (see AppRoutes). Kept out of production
// builds by this flag being a build-time constant.
export const isRouteDebugEnabled =
  import.meta.env.VITE_MODE === "development" ||
  import.meta.env.VITE_MODE === "debug";
